'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_pages_IngredientsPage$State(groceryItems, count_$_lo, count_$_hi, activePage, editing, editingSynonyms, msgState) {
  this.rm = null;
  this.s0 = 0;
  this.s1 = 0;
  this.oK = 0;
  this.nx = null;
  this.uI = null;
  this.q5 = null;
  this.rm = groceryItems;
  this.s0 = count_$_lo;
  this.s1 = count_$_hi;
  this.oK = activePage;
  this.nx = editing;
  this.uI = editingSynonyms;
  this.q5 = msgState;
}
export { $c_Lmealorama_pages_IngredientsPage$State as $c_Lmealorama_pages_IngredientsPage$State };
$p = $c_Lmealorama_pages_IngredientsPage$State.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_pages_IngredientsPage$State;
/** @constructor */
function $h_Lmealorama_pages_IngredientsPage$State() {
}
export { $h_Lmealorama_pages_IngredientsPage$State as $h_Lmealorama_pages_IngredientsPage$State };
$h_Lmealorama_pages_IngredientsPage$State.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, 80204913);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.rm));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().xT(this.s0, this.s1));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, this.oK);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.nx));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.uI));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.q5));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 6);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_pages_IngredientsPage$State)) {
    var x_$_lo = this.s0;
    var x_$_hi = this.s1;
    var $x_3 = x$0;
    var x$1_$_lo = $x_3.s0;
    var x$1_$_hi = $x_3.s1;
    if (((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0) && (this.oK === x$0.oK))) {
      var x$2 = this.rm;
      var x$2$1 = x$0.rm;
      var $x_2 = ((x$2 === null) ? (x$2$1 === null) : x$2.f(x$2$1));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.nx;
      var x$4 = x$0.nx;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_1 = false;
    }
    if (($x_1 && (this.uI === x$0.uI))) {
      var x$5 = this.q5;
      var x$6 = x$0.q5;
      return ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 6;
});
$p.r = (function() {
  return "State";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.rm;
      break;
    }
    case 1: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.s0, this.s1);
      break;
    }
    case 2: {
      return this.oK;
      break;
    }
    case 3: {
      return this.nx;
      break;
    }
    case 4: {
      return this.uI;
      break;
    }
    case 5: {
      return this.q5;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_pages_IngredientsPage$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kt)));
}
export { $isArrayOf_Lmealorama_pages_IngredientsPage$State as $isArrayOf_Lmealorama_pages_IngredientsPage$State };
var $d_Lmealorama_pages_IngredientsPage$State = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_pages_IngredientsPage$State, "mealorama.pages.IngredientsPage$State", ({
  kt: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_pages_IngredientsPage$State as $d_Lmealorama_pages_IngredientsPage$State };
//# sourceMappingURL=mealorama.pages.-Ingredients-Page$-State.js.map
